import items from "@/apis/items"
import { itemsTypes } from "@/store/mutationTypes";

export default {
    namespaced: true,
    state: {
        combos: [],
        menuItems: [],
        fetchAllCombos: {
            pending: false,
            error: null,
        },
        fetchAllMenuItems: {
            pending: false,
            error: null,
        },
    },
    mutations: {
        [itemsTypes.FETCH_ALL_COMBOS_REQUEST]: function (state) {
            state.fetchAllCombos.pending = true
            state.fetchAllCombos.error = null
        },
        [itemsTypes.FETCH_ALL_COMBOS_SUCCESS]: function (state, combos) {
            state.fetchAllCombos.error = null
            state.fetchAllCombos.pending = false
            state.combos = combos
        },
        [itemsTypes.FETCH_ALL_COMBOS_FAILURE]: function (state, error) {
            state.fetchAllCombos.error = error
            state.fetchAllCombos.pending = false
        },
        [itemsTypes.FETCH_ALL_MENU_ITEMS_REQUEST]: function (state) {
            state.fetchAllMenuItems.pending = true
            state.fetchAllMenuItems.error = null
        },
        [itemsTypes.FETCH_ALL_MENU_ITEMS_SUCCESS]: function (state, menuItems) {
            state.fetchAllMenuItems.error = null
            state.fetchAllMenuItems.pending = false
            state.menuItems = menuItems
        },
        [itemsTypes.FETCH_ALL_MENU_ITEMS_FAILURE]: function (state, error) {
            state.fetchAllMenuItems.error = error
            state.fetchAllMenuItems.pending = false
        },
    },
    actions: {
        async fetchAllCombos({ commit }) {
            commit(itemsTypes.FETCH_ALL_COMBOS_REQUEST)
            return new Promise((resolve, reject) => {
                items
                    .fetchAllCombos()
                    .then(({ data }) => {
                        commit(itemsTypes.FETCH_ALL_COMBOS_SUCCESS, data)
                        resolve(data)
                    })
                    .catch((error) => {
                        commit(itemsTypes.FETCH_ALL_COMBOS_FAILURE, error)
                        reject(error)
                    })
            })
        },
        async fetchAllMenuItems({ commit }) {
            commit(itemsTypes.FETCH_ALL_MENU_ITEMS_REQUEST)
            return new Promise((resolve, reject) => {
                items
                    .fetchAllMenuItems()
                    .then(({ data }) => {
                        commit(itemsTypes.FETCH_ALL_MENU_ITEMS_SUCCESS, data)
                        resolve(data)
                    })
                    .catch((error) => {
                        commit(itemsTypes.FETCH_ALL_MENU_ITEMS_FAILURE, error)
                        reject(error)
                    })
            })
        },
    }
}
